import { render, staticRenderFns } from "./taskrecord.vue?vue&type=template&id=6492958a&"
import script from "./taskrecord.vue?vue&type=script&lang=js&"
export * from "./taskrecord.vue?vue&type=script&lang=js&"
import style0 from "./taskrecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports